import React from "react";
import DashboardFinancieroVentas from "../components/DashboardFinancieroVentas";

const InformeDashboardFinanciero = () => {
  return (
    <>
      <DashboardFinancieroVentas />
    </>
  );
};

export default InformeDashboardFinanciero;